exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#no-orders-to-edit[data-v-5a7b08a9]{color:#ea4726;font-weight:700;padding:1rem 0 2rem 0}.order-rows[data-v-5a7b08a9]{background:#fff;margin:0 -18px}.order-rows[data-v-5a7b08a9] .order_row{margin:0}", ""]);

// exports
